import React, { Component } from "react";
import Registry from "../../../Utils/Registry";

import TYItem from "../../TYItem";
import { NotificationManager } from "react-notifications";

import Vars from "../../../Utils/Variables";

class OperationsRecurrentDetailsVehicle extends Component{
    constructor(props){
        super(props);

        this.api = Registry.registered("api");

        this.state = {
            loading: false
        };
    }

    deleteVehicle = () => {
        this.setState({loading: true});
        this.api.del(`/recurrent/vehicle/${this.props.data.id}`)
            .then(_ => {
                NotificationManager.success("Véhicule supprimé");
                if(this.props.onUpdate)
                    this.props.onUpdate();
                else
                    this.setState({loading: false});
            })
            .catch(_ => {
                NotificationManager.error("Impossible de supprimer le véhicule");
                this.setState({loading: false});
            });
    }

    render(){
        const { data, onUpdateClicked, ...props } = this.props;
        return <div className="ty-list-item marg-b-5" >
            <TYItem
                icon="icon icon-car"
                actions={!this.state.loading ? [
                    { label: "Modifier", onclick: () => { onUpdateClicked(data); } },
                    { label: "Supprimer", onclick: this.deleteVehicle }
                ] : []}
                flagColorCode={ data.gas_color || "#c2cfd6" }
            >
                {
                    this.state.loading ?
                        <div className="center">
                            <i className="icon icon-loading animated spin infinite f-20"> </i>
                        </div> 
                        :
                        <div>
                            { data.description + " - " + data.plate }
                            <div className="f-12">
                                { Vars.energies[data.energy_type].label } -&nbsp;
                                { 
                                    data.energy_type === 0 ? 
                                        <span style={{color: data.gas_color}}>{ data.gas_name }</span>
                                        : 
                                        Vars.energies[data.energy_type].subTypes[data.energy_sub_type].label 
                                }
                            </div>
                            
                        </div>
                }
            </TYItem>
        </div>
    }
}

OperationsRecurrentDetailsVehicle.defaultProps = {
    data: {},
    onUpdate: () => {},
    onUpdateClicked: _ => {}
};

export default OperationsRecurrentDetailsVehicle;



// WEBPACK FOOTER //
// ./src/components/Operations/Recurrent/vehicle.js